import { ScalarVariable } from './ScalarVariable';

export class UserType {
  /** @constructor */
  constructor(public name: string, public members: any) {
    // this.name = name;
    // Members: A mapping of names to types.
    // this.members = members;
  }

  createInstance() {
    const user: any = {};

    for (const name in this.members) {
      user[name] = new ScalarVariable(
        this.members[name],
        this.members[name].createInstance()
      );
    }

    return user;
  }

  copy(value: any) {
    const newValue: any = {};
    for (const key in value) {
      newValue[key] = value[key].copy();
    }

    return newValue;
  }
}
